import React from "react";
import "./WelcomeBonusPopup.css";

const WelcomeBonusPopup = ({ show, amount, message, onClose }) => {
    if (!show) return null;

    return (
        <div className="wb-overlay">
            <div className="wb-popup">
                <button className="wb-close-btn" onClick={onClose}>×</button>

                <h2 className="wb-title">🎉 Welcome Bonus!</h2>

                <div className="wb-amount">+ ₹{amount}</div>

                <p className="wb-message">{message}</p>

                <button className="wb-ok-btn" onClick={onClose}>
                    Okay
                </button>
            </div>
        </div>
    );
};

export default WelcomeBonusPopup;
